<template>
  <div />
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    chartDataX: {
      type: Array,
    },
    chartDataY: {
      type: Array,
    },
    legendData: {
      type: Array,
    },
    title: {
      type: "",
    },
  },
  data() {
    //防抖
    const debounce = (fn) => {
      let timer;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn();
        }, 200);
      };
    };
    return {
      chart: null,
      cancalDebounce: debounce(this.windowResize),
    };
  },
  mounted() {
    this.$nextTick(() => {
      //解决数据还没初始化就初始化表格的bug
      setTimeout(() => {
        this.initChart();
      }, 200);
    });
    window.addEventListener("resize", this.cancalDebounce);
  },
  methods: {
    windowResize() {
      //销毁图表重新画;
      setTimeout(() => {
        this.chart.dispose();
        this.initChart();
      }, 100);
    },
    initChart() {
      this.chart = echarts.init(this.$el);

      this.setOptions();
      //添加legend的监听
      this.chart.on("legendselectchanged", (params) => {
        if (params.name == "湿度") {
          console.log(params.selected["湿度"]);
          this.$store.state.humiditySelected = params.selected["湿度"];
        }
      });
    },
    setOptions() {
      if (!this.chart) {
        return;
      }
      const rootFontSize = parseFloat(
        window.getComputedStyle(document.documentElement)["font-size"]
      );
      const fontSizeRem = 0.8;
      const fontSizePx = rootFontSize * fontSizeRem;

      this.chart.setOption({
        // backgroundColor:'#06111A',
        textStyle: {
          fontSize: fontSizePx, // 设置字体大小为 14
        },
        tooltip: {
          trigger: "axis",
          confine: true, //解决提示框越界
          formatter: (params) => {
            //自定义提示框
            if (params.length > 0 && params[0].seriesName == "温度") {
              let relVal = params[0].name;
              for (var i = 0, l = params.length; i < l; i++) {
                relVal +=
                  "<br/>" +
                  params[i].marker +
                  params[i].seriesName +
                  " : " +
                  params[i].value +
                  (params[i].seriesName == "温度" ? "°C" : "%");
              }
              return relVal;
            } else if (params.length > 0 && params[0].seriesName == "x") {
              let relVal = params[0].name;
              for (var i = 0, l = params.length; i < l; i++) {
                relVal +=
                  "<br/>" +
                  params[i].marker +
                  params[i].seriesName +
                  " : " +
                  params[i].value +
                  " °";
              }
              return relVal;
            } else {
              let relVal = params[0].name;
              for (var i = 0, l = params.length; i < l; i++) {
                relVal +=
                  "<br/>" +
                  params[i].marker +
                  params[i].seriesName +
                  " : " +
                  params[i].value +
                  " ap";
              }
              return relVal;
            }
          },
        },
        legend: {
          top: "-0%",
          data: this.legendData,
          textStyle: { color: "#7F8488" },
          // selected: { 湿度: this.$store.state.humiditySelected }, //默认不选温度
          selected: {
            //   "偏航电机#1": this.$store.state.YawmotorSelected1,
            //  "偏航电机#2": this.$store.state.YawmotorSelected2,
            //   "偏航电机#3": this.$store.state.YawmotorSelected3,
            //   "偏航电机#4": this.$store.state.YawmotorSelected4,
          }, //默认不选温度
        },

        grid: {
          top: "30%",
          left: "13%",
          right: "13%",
          bottom: "15%",
        },
        xAxis: {

         axisLine: {
              lineStyle: { color: "#7F8488" },
            },
          type: "category",
          data: [
            "22日00时",
            "22日01时",
            "22日02时",
            "22日03时",
            "22日04时",
            "22日05时",
            "22日06时",
            "22日07时",
            "22日08时",
            "22日09时",
            "22日10时",
            "22日11时",
            "22日12时",
            "22日13时",
            "22日14时",
            "22日15时",
            "22日16时",
            "22日17时",
            "22日18时",
            "22日19时",
            "22日20时",
            "22日22时",
            "22日22时",

          ],
        },
        // xAxis: {
        //   data: this.chartDataX,
        //   boundaryGap: false,
        //   axisLine: {
        //     lineStyle: { color: "#7F8488" },
        //   },
        //   axisLabel: {
        //     textStyle: {
        //       fontSize: fontSizePx,
        //     },
        //   },
        // },
        yAxis: {
          splitLine: {
            show: true,
            lineStyle: { color: ["#244447"], width: 1, type: "dashed" },
          },
          axisLine: {
            lineStyle: { color: "#7F8488" },
          },
          axisLabel: {
            textStyle: {
              fontSize: fontSizePx,
            },
          },
        },
        series: [
          {
            type: "line",
            name: "主轴_1",
            data: [
              1045, 1054, 1046, 1098, 1159, 944, 1175, 1381, 1367, 1045, 1018,
              791, 670, 650, 610, 550, 770, 650, 870,650, 660, 842, 747, 723,770,
            ],
            // markLine: {
            //   label: { color: "#7F8488" },
            //   data: [
            //     { type: "max", name: "max" },
            //     { type: "min", name: "min" },
            //   ],
            // },
            showSymbol: false,
            itemStyle: { color: "#00d1ed" },

          },
          {
            type: "line",
            name: "主轴_2",
            data: [
              1433, 1550, 1654, 1527, 1644, 1630, 1563, 1598, 1791, 2023, 2268,
              1959, 2143, 2763,  1433, 1550, 1654, 1527, 1644, 1630, 1563, 1744, 1533, 1256,  1533,
            ],
            // markLine: {
            //   label: { color: "#7F8488" },
            //   data: [
            //     { type: "max", name: "max" },
            //     { type: "min", name: "min" },
            //   ],
            // },
            showSymbol: false,
            itemStyle: { color: "#e6a23c" },

          },
        ],
        // series: this.chartDataY,
      });
    },
  },
  watch: {
    chartDataX: {
      deep: true,
      handler: function () {
        if (this.chart) {
          this.chart.dispose();
        }
        this.initChart();
        this.setOptions();
      },
    },
    // chartDataY: {
    //   deep: true,
    //   handler: function () {
    //     this.setOptions();
    //   },
    // },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/lineChart.vue